import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiReferensiPembayaranHutangService = new CrudCustom('/transaksi-referensi-pembayaran-hutangs');
export default TransaksiReferensiPembayaranHutangService;
